/** Dual NTEN / AN26 class names for backwards-compatible styling. */
export function chartCls(suffix: string): string {
  return `nten-${suffix} an26-${suffix}`;
}

/** Empty-state wrapper class names. */
export function emptyStateCls(): string {
  return chartCls("data-empty");
}
